import axios from "axios";

export default {
  getStreetFromCoordinates (params) {
   return axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng="+params.lat+","+params.lng+"&key=AIzaSyBfjvF10C7dGFwRpGrqdx4PidsoXKmERP8")
}
}



// WEBPACK FOOTER //
// ./src/services/GoogleService.js